export default {
  data() {
    return {
      //pie
      dashboard115PieChartOptions: {
        colors: [
          '#665FBB',
          '#B6DCFE',
          '#B8B8F3',
          '#55BCE8',
          '#D1D0A3',
          '#298A9B',
          '#D6558B',
          '#FFD2FC',
          '#E6E6E9',
          '#1D4E89',
          '#E2856E',
          '#775048',
        ],
        chart: {
          renderTo: 'dashboard115PieChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'نتیجه تماس ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //data
      // dashboardIMG: require('@/assets/images/dashboard.png'),
      dashboardIMG: require('@/assets/images/bg_card_line.svg'),
      dashboardBG: require('@/assets/images/bg_card.svg'),
      dashboard115Time: '',
      dashboard115TimeInterval: '',
      dashboard115TimeCall: null,
      dashboard115CallsCount: null,
      dashboard115TriageCount: null,
      dashboard115LocationCount: null,
      dashboard115DndDuration: null,
      //column chart
      dashboard115ColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: [],
          useHTML: true,
          reversed: false,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            style: {
              backgroundColor: 'rgba(252, 255, 197, 0.7)',
              color: 'black',
              borderWidth: 1,
              wordWrap: 'break-word',
            },
            enabled: true,
            useHTML: true,
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          backgroundColor: '#000000',
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{series.name}</span>: <span  style="color:white">{point.y}</span></div>',
        },
        plotOptions: {
          useHTML: true,
          series: {
            borderWidth: 0,
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{series.name}: {point.y}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '9px',
                wordWrap: 'break-word',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
      },
      //line chart
      dashboard115LineChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          categories: [],
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [
          {
            name: 'تماس ها',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    ready115Dashboard: function (data) {
      //pie chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.callsTag));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.dashboard115PieChartOptions.series[0].data = [];
      this.dashboard115PieChartOptions.series[0].data = pieChartData;
      //data card
      let duration = Math.round(data.workingHours.valueDouble);
      let duration2 = Math.round(data.responseTimeAverage.valueDouble);
      let duration3 = Math.round(data.dndDuration.valueLong);
      duration = duration * 1000;
      duration2 = duration2 * 1000;
      duration3 = duration3 * 1000;
      this.dashboard115TimeCall = this.msToTime(duration2);
      this.dashboard115DndDuration = this.msToTime(duration3);
      this.dashboard115TimeInterval = setInterval(() => {
        duration = duration + 1000;
        this.dashboard115Time = this.msToTime(duration);
      }, 1000);
      this.dashboard115CallsCount = data.callsCount.valueLong;
      this.dashboard115LocationCount = data.locationConfirmed.valueLong;
      this.dashboard115TriageCount = data.triagesCount.valueLong;
      //cloumn
      if (data.diagnoses.length > 0) {
        let columnData = [];
        for (let i = 0; i < data.diagnoses.length; i++) {
          this.dashboard115ColumnChartOptions.xAxis.categories.push(data.diagnoses[i].title);
        }
        for (let j = 0; j < data.diagnoses[0].subItems.length; j++) {
          columnData.push({
            name: data.diagnoses[0].subItems[j].title,
            data: [],
          });
        }
        for (let i = 0; i < columnData.length; i++) {
          for (let j = 0; j < data.diagnoses.length; j++) {
            for (let z = 0; z < data.diagnoses[j].subItems.length; z++) {
              if (columnData[i].name == data.diagnoses[j].subItems[z].title) {
                if (data.diagnoses[j].subItems[z].valueLong > 0) {
                  columnData[i].data.push(data.diagnoses[j].subItems[z].valueLong);
                } else {
                  columnData[i].data.push(null);
                }
              }
            }
          }
        }
        this.dashboard115ColumnChartOptions.series = columnData;
      }
      //line
      if (data.callsBasedOnDate.length > 0) {
        for (let i = 0; i < data.callsBasedOnDate.length; i++) {
          let text = data.callsBasedOnDate[i].title.split(' ');
          this.dashboard115LineChartOptions.xAxis.categories.push(text[1]);
          this.dashboard115LineChartOptions.series[0].data.push(data.callsBasedOnDate[i].valueLong);
        }
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
